export default __webpack_public_path__ + "static/media/gallery-wip-assembly_01.51be4249.jpg";